import { createApp } from 'vue'
import _ from 'lodash'

//css
import '@/assets/style.css';
import '@/assets/fonts/WWFGatveder/style.css';
import '@/assets/fonts/wwf/wwf.css';

import App from './App.vue'
import store from './store'

//lodash
var lodash = _.noConflict();
const appContainers = document.getElementsByClassName('pxrwwfgv-app');

lodash.forEach(appContainers, (appContainer) => {
	createApp(App)
		.use(store)
		.mount(appContainer);
});